import { render, staticRenderFns } from "./MoreEntrance.vue?vue&type=template&id=399346a3&scoped=true&"
import script from "./MoreEntrance.vue?vue&type=script&lang=tsx&"
export * from "./MoreEntrance.vue?vue&type=script&lang=tsx&"
import style0 from "./MoreEntrance.vue?vue&type=style&index=0&id=399346a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399346a3",
  null
  
)

export default component.exports